<template>
  <div class="winning-together-button">
    <separator/>
    <div @click="openPopup" class="winning-together">
איך לנצח את החודש הבא?
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import WinningTogetherPopup
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/past-editable-month/components/WinningTogetherPopup';
import ModalBus from '@/event-bus/modal-bus';
import Segment from '@/Segment';

export default {
  name: 'WinningTogetherButton',
  components: {
    Separator: BaseUI.Separator,
  },
  methods: {
    openPopup() {
      Segment.trackUserInteraction('WinningTogetherClicked');
      ModalBus.$emit('open', {
        component: WinningTogetherPopup,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';
  .winning-together-button {
    .winning-together {
      padding: 17px 0;
      color: $riseup_light_blue;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
    }
  }
</style>
